<template>
  <div class="modal">
    <div class="button-area">
      <SmallButton
        title="今すぐ配信"
        class="button"
        :disabled="isAxiosWait"
        @click="onClickStreamingNowButton"
      />
      <SmallButton
        title="予約配信"
        class="button scheduled-button"
        :disabled="isAxiosWait"
        @click="moveSchedulingPage"
      />
      <SmallButton
        title="キャンセル"
        class="button cancel-button"
        :disabled="isAxiosWait"
        @click="closeModal"
      />
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';

import SmallButton from '@/components/common/SmallButton.vue';
import { postStreamingStreamGroup } from '@/composable/data_push_common';

const props = defineProps({
  selectedStreamGroupId: Number,
  moveSchedulingPage: Function,
  closeModal: Function,
  getStreamGroup: Function,
});

// axios処理待ち
const isAxiosWait = ref(false);

const onClickStreamingNowButton = () => {
  // 通信処理中の場合は処理中止
  if (isAxiosWait.value) return;

  isAxiosWait.value = true;
  // 配信ステータス更新処理
  postStreamingStreamGroup(props.selectedStreamGroupId)
    .then(() => {
      props.getStreamGroup();
      props.closeModal();
    })
    .finally(() => {
      isAxiosWait.value = false;
    });
};
</script>

<style scoped>
/** モーダル */
.modal {
  background: #fff;
  border-radius: 10px;
  height: auto;
  margin: auto;
  overflow: scroll;
  max-width: 84rem;
  width: 80%;
  white-space: normal;
}
/** ボタンエリア */
.button-area {
  margin: auto;
  padding: 3rem;
}
.button:not(:last-child) {
  margin-bottom: 1.5rem;
}
.scheduled-button {
  background-color: white;
  border: 1px #ccc solid;
  color: #222;
}
.cancel-button {
  background-color: white;
  border: none;
  color: #222;
}
</style>
